/* eslint-disable no-await-in-loop */
/* eslint-disable curly */
/* eslint-disable max-len */
/* eslint-disable max-depth */
import JSZip from 'jszip';
import { PDFDocument } from 'pdf-lib';

export default {
  methods: {
    async downloadDocuments(modeSelected) {
      this.loadingDocument = true;
      this.$bvModal.hide('modalTypeDownload');
      try {
        const { documents, elementId } = await this.getDocumentsByType();
        if (documents.length === 0) return this.$toast.success('Aviso', 'No hay documentos para descargar');

        const downloadModes = {
          single: { callback: this.singleDocument, title: `${elementId}_${this.type}.pdf` },
          grouped: { callback: this.unifyDocuments, title: `${elementId}_${this.type}.pdf` },
          compressed: { callback: this.compressDocuments, title: `${elementId}_${this.type}` }
        };
        const { callback, title } = downloadModes[modeSelected];
        const parsedDocuments = await callback(documents, elementId);
        
        // Evitar doble descarga
        if (modeSelected !== 'compressed') this.download(parsedDocuments, title);

        // Update document downloaded flag
        this.updateDownloadFlags();
      } catch (err) {
        this.$toast.error('Error durante la descarga', 'No se han podido descargar los documentos.');
      } finally {
        this.loadingDocument = false;
        this.$root.$emit(`refresh_${this.type}`);
      }
    },

    async getDocumentsByType() {
      const documents = [];
      let elementId;

      if (this.type === 'account') {
        try {
          elementId = this.account.id_object;
          documents.push({
            entity_id: elementId,
            documents: await this.getAccountDocuments(this.uuid)
          });

          for (const intervener of this.account.interveners) {
            const intervenerDocs = await this.getIntervenerDocuments(intervener.uuid, this.uuid);
            if (intervenerDocs.length > 0) {
              documents.push({
                entity_id: intervener.personal_data.id_object,
                documents: intervenerDocs
              });
            }
          }

          const res = await this.$accountsService.getAccountOperations(this.uuid);
          const operations = res.data.related_operations;

          for (const operation of operations) {
            if (!['VALIDATED', 'RD_SENT', 'FINALIZED'].includes(operation.operation_status)) {
              const document = await this.getOperationDocuments(operation.operation_code);
              if (document.length > 0) {
                documents.push({
                  entity_id: `${operation.id_object}_${this.account.id_object}`,
                  documents: document
                });
              }
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
      if (this.type === 'operation') {
        if (!['VALIDATED', 'RD_SENT', 'FINALIZED'].includes(this.operation.operation_status)) {
          elementId = this.operation.id_object;
          const operationDocuments = await this.getOperationDocuments(this.uuid);
          if (operationDocuments.length > 0) {
            documents.push({
              entity_id: elementId,
              documents: operationDocuments
            });
          }
        }
      }
      if (this.type === 'intervener') {
        elementId = this.intervener.personal_data.id_object;
        const intervenerDocs = await this.getIntervenerDocuments(this.intervener.uuid);
        if (intervenerDocs.length > 0) {
          documents.push({
            entity_id: this.intervener.personal_data.id_object,
            documents: intervenerDocs
          });
        }
      }

      return { documents, elementId };
    },

    async getIntervenerDocuments(intervenerUuid, uuidAccount = '') {
      const intervenerDocuments = [];
      const cfg = {};

      try {
        if (uuidAccount) {
          cfg.params = {
            $filter: `{"uuid":[{"eq": "${uuidAccount}" }]}`
          };
        }

        const response = await this.$intervenersService.getIntervenerDocumentsValidations(intervenerUuid, cfg);
        let documents = response.data.interveners_documents
          .filter(doc => doc.title && doc.uuid)
        if (this.isPartialDownload) {
          documents = documents.filter(doc => doc.uuid === this.selectedItem.uuid);
        }
        for (const document of documents) {
          const downloaded = await this.$intervenersService.downloadIntervenerDocument(
            document.uuid_intervener,
            document.uuid
          );
          if (documents.length > 0) {
            downloaded.title = document.key_subcategory;
            downloaded.is_signable = document.is_signable;
            intervenerDocuments.push(downloaded);
          }
        }
        return intervenerDocuments;
      } catch (err) {
        console.error(err);
        throw new Error(`downloadIntervenerDocuments: ${err}`);
      }
    },

    async getAccountDocuments(accountUuid) {
      const accountDocuments = [];
      try {
        const response = await this.$accountsService.getAccountDocumentsValidations(accountUuid);
        let documents = response.data.accounts_documents.filter( doc => doc.title && doc.uuid );
        if (this.isPartialDownload) {
          documents = documents.filter(doc => doc.uuid === this.selectedItem.uuid);
        }
        for (const document of documents) {
          const downloaded = await this.$accountsService.downloadAccountDocument(document.uuid_account, document.uuid);
          downloaded.title = document.title;
          downloaded.is_signable = document.is_signable;
          accountDocuments.push(downloaded);
        }
        return accountDocuments;
      } catch (err) {
        console.error(err);
        throw new Error(`downloadAccountDocuments: ${err}`);
      }
    },

    async getOperationDocuments(operationUuid) {
      const operationDocuments = [];
      try {
        const response = await this.$operationsService.getDocumentsValidations(operationUuid);
        let documents = response.data.operation_documents.filter( doc => doc.title && doc.uuid );
        if (this.isPartialDownload) {
          documents = documents.filter(doc => doc.uuid === this.selectedItem.uuid);
        }
        for (const document of documents) {
          const downloaded = await this.$operationsService.downloadOperationDocument(
            document.uuid_operation,
            document.uuid
          );
          downloaded.title = document.key_subcategory;
          downloaded.is_signable = document.is_signable;
          operationDocuments.push(downloaded);
        }
        return operationDocuments;
      } catch (err) {
        console.error(err);
        throw new Error(`downloadOperationDocuments: ${err}`);
      }
    },

    async compressDocuments(bulkDocuments) {
      const zip = new JSZip();
      for (const documents of bulkDocuments) {
        const entityId = documents.entity_id;
        documents.documents.forEach(document => {
          const data = document.data ? document.data : document;

          let ext = 'pdf';
          const type = data?.type || '';
          if (type.includes('xml')) ext = 'xml';
          else if (type.includes('jpeg')) ext = 'jpg';
          else if (type.includes('png')) ext = 'png';
          else if (type.includes('plain')) ext = 'txt';
          else if (type.includes('msword')) ext = 'doc';
          else if (type.includes('officedocument.wordprocessingml')) ext = 'docx';
          else if (type.includes('zip')) ext = 'zip';

          const title = `${entityId}_${document.title}.${ext}`;
          zip.file(title, data, { base64: true });
        });
      }

      if (zip.files && Object.keys(zip.files).length > 0) {
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        this.downloadZip(zipBlob, `documentos_${Date.now()}.zip`);
      } else {
          alert('No se encontraron archivos válidos para descargar.');
      }
    },

    downloadZip(zipBlob, title) {
      const link = document.createElement('a');
      const urlCreator = window.URL || window.webkitURL;
      link.href = urlCreator.createObjectURL(zipBlob);
      link.download = title;
    
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
      URL.revokeObjectURL(link.href);
      window.addEventListener('focus', () => URL.revokeObjectURL(link.href), { once: true });
    },    

    async unifyDocuments(bulkDocuments) {
      const mergedPdf = await PDFDocument.create();
      let addedPages = 0;
      for (const documents of bulkDocuments) {
        for (const document of documents.documents) {
          try {
            // Detectar si es PDF
            const isPdf = document.data.type?.includes('application/pdf');
            const isSignable = document.is_signable;
            if (!isPdf || !isSignable) continue;

            const pdfBytes = await document.data.arrayBuffer();
            const pdf = await PDFDocument.load(pdfBytes, { ignoreEncryption: true });
            const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
            copiedPages.forEach(page => mergedPdf.addPage(page));
            addedPages += copiedPages.length;
          } catch (err) {
            console.error(`Error procesando ${document.title}:`, err);
          }
        }
      }

      // Si no hay páginas agregadas, avisar y evitar devolver un Blob vacío
      if (addedPages === 0) {
        this.$toast.warning('Aviso', 'No hay documentos PDF válidos para descargar.');
        return null;
      }

      const mergedBytes = await mergedPdf.save();
      return new Blob([mergedBytes], { type: 'application/pdf' });
    },

    singleDocument(bulkDocuments) {
      return bulkDocuments.length && bulkDocuments[0] && bulkDocuments[0].documents[0]
        ? bulkDocuments[0].documents[0].data
        : bulkDocuments;
    },

    async download(content, title) {
      try {
        // Si no es un Blob, intenta convertirlo
        let blob;
        if (content instanceof Blob) {
          blob = content;
        } else if (content?.data instanceof Blob) {
          blob = content.data;
        } else if (typeof content === 'string') {
          // si por algún motivo llega en base64
          const binary = atob(content);
          const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
          blob = new Blob([bytes], { type: 'application/pdf' });
        } else {
          return;
        }

        // Si el blob está vacío
        if (!blob.size) {
          this.$toast.warning('Aviso', 'El documento está vacío o no disponible.');
          return;
        }

        // Crear un enlace de descarga
        const link = document.createElement('a');
        const urlCreator = window.URL || window.webkitURL;
        link.href = urlCreator.createObjectURL(blob);
        link.download = title;

        // Agregar el enlace al cuerpo del documento y simular un clic
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revocar la URL del objeto creado
        URL.revokeObjectURL(link.href);
        window.addEventListener('focus', () => URL.revokeObjectURL(link.href), { once: true });
      } catch (error) {
        console.error('Error al descargar el documento PDF:', error);
        this.$toast.error('Error', 'No se pudo descargar el documento.');
      }
    },


    async updateDownloadFlags() {
      if (this.type === 'account') {
        await this.$accountsService.updateAccountInfo(this.uuid, { has_docs_been_downloaded: true });
        this.account.interveners.forEach(async intervener => {
          await this.$intervenersService.updateIntervenerInfo(intervener.uuid, {
            has_docs_been_downloaded: true
          });
        });
        this.accountOperations
          .filter(operation => !['VALIDATED', 'RD_SENT', 'FINALIZED'].includes(operation.operation_status))
          .forEach(async operation => {
            await this.$operationsService.updateOperation(operation.operation_code, {
              has_docs_been_downloaded: true
            });
          });
      }

      if (this.type === 'operation') {
        await this.$operationsService.updateOperation(this.operation.operation_id, {
          has_docs_been_downloaded: true
        });
        this.operation.interveners.forEach(async intervener => {
          await this.$intervenersService.updateIntervenerInfo(intervener.uuid, {
            has_docs_been_downloaded: true
          });
        });
      }

      if (this.type === 'intervener') {
        await this.$intervenersService.updateIntervenerInfo(this.intervener.uuid, {
          has_docs_been_downloaded: true
        });
      }
    }
  }
};
